import searchRecordsFacetsConfig from './search-records-facets.config';

export default {
  title: 'Bibliografia',
  searchId: 'record',
  searchConfig: searchRecordsFacetsConfig,
  resourcePath: '/records',
  facetsTitle: 'search#facets_title',
  totalResultsText: 'search#works_total',
  filtersTitle: 'search#filters_title',
  grid: 1,
  sort: {
    label: 'search#sort_title',
    options: [
      {
        value: 'sort_title.keyword_ASC',
        label: 'search#sort_label_ciclo',
        selected: true,
        disabled: false
      },
      {
        value: 'title.sort_ASC',
        label: 'search#sort_asc',
        selected: false
      },
      {
        value: 'title.sort_DESC',
        label: 'search#sort_desc',
        selected: false
      }
    ]
  },
  pagination: {
    limit: 5,
    options: [
      12,
      24,
      48
    ]
  },
  itemPreview: {
    classes: 'is-vertical'
  },
  fallback: {
    text: 'search#fallback_text',
    button: 'search#fallback_button'
  },
  ko: {
    text: 'search#ko_text',
    button: 'search#ko_button'
  }
};
